import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, IconButton } from '@mui/material';
import { debounce } from 'lodash';
import DeleteIcon from '@mui/icons-material/Delete';
import { Input, Layout, Loading, UserNavbar } from '../../../components';
import VendorEventsTable from './VendorEventsTable';
import { setPaginationData } from './redux/vendorEventsActions';

const inputStyles = {
  backgroundColor: '#fffdfd98',
  borderRadius: 50,
  width: '100vw',
  height: 95,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#EE7B57',
};

function VenueApplications() {
  const loading = useSelector((state) => state.vendorEventsPaginated.loading);
  const dispatch = useDispatch();
  const pagination = useSelector((state) => state.vendorEventsPaginated.pagination);
  const { search } = pagination;

  const handleOnSearch = debounce((event) => {
    dispatch(setPaginationData({ ...pagination, search: event.target.value }));
  }, 500);

  const clearFilters = () => {
    dispatch(setPaginationData({ ...pagination, search: '' }));
  };

  return (
    <Layout>
      <UserNavbar />
      {loading && <Loading />}

      <Grid container justifyContent="center" marginTop={30}>
        <Grid item xs={9} style={inputStyles} marginBottom={3}>
          <h1 style={{ textAlign: 'center' }}>Venue Applications </h1>
        </Grid>
        <Grid item xs={9} style={inputStyles}>
          <Input
            type="text"
            style={{ width: '65vw', marginTop: 4 }}
            placeholder="Typing some here..."
            onChange={handleOnSearch}
          />
          {search && (
            <IconButton onClick={clearFilters}>
              <DeleteIcon />
            </IconButton>
          )}
        </Grid>
      </Grid>
      <Grid container justifyContent="center" marginTop={5}>
        <Grid item xs={10}>
          <VendorEventsTable />
        </Grid>
      </Grid>
    </Layout>
  );
}

VenueApplications.propTypes = {};

export default VenueApplications;
